import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { WhoAreWe } from './components/WhoAreWe';
import { Footer } from './components/Footer';
import { AccessibilityMenu } from './components/AccessibilityMenu';
import { TopBanner } from './components/TopBanner';
import { FAQ } from './pages/FAQ';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { Employees } from './pages/Employees';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen flex flex-col bg-white overflow-x-hidden" data-id="element-1">
        <div className="relative z-40" data-id="element-2">
          <TopBanner data-id="element-3" />
        </div>
        <Header data-id="element-4" />
        <main className="flex-grow" data-id="element-5">
          <Routes data-id="element-6">
            <Route path="/" element={<Home data-id="element-8" />} data-id="element-7" />
            <Route path="/about" element={<About data-id="element-10" />} data-id="element-9" />
            <Route path="/services" element={<Services data-id="element-12" />} data-id="element-11" />
            <Route path="/employees" element={<Employees data-id="element-14" />} data-id="element-13" />
            <Route path="/faq" element={<FAQ data-id="element-16" />} data-id="element-15" />
          </Routes>
        </main>
        <Footer data-id="element-17" />
        <AccessibilityMenu data-id="element-18" />
      </div>
    </BrowserRouter>;
}